import React from 'react';
import styled, { css } from 'styled-components';
import { ReactComponent as BaseAttentionIcon } from '@ubeya/shared-web/assets/info.svg';

const AttentionIcon = styled(BaseAttentionIcon)`
  width: 20px;
  height: 20px;
`;

const InfoIcon = styled(AttentionIcon)`
  transform: rotate(180deg);
  width: 20px;
  height: 20px;
`;

const typeStyles = {
  info: {
    background: 'blueLight',
    border: 'blueLight',
    color: 'black',
    Icon: InfoIcon
  }
};

const Box = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 16px 16px;
  border-radius: 4px;
  font-size: 14px;
  gap: 8px;
  ${({ $type, theme }) => css`
    background-color: ${theme.colors[typeStyles[$type].background]};
    border-color: ${theme.colors[typeStyles[$type].border]};
    color: ${theme.colors[typeStyles[$type].color]};
  `}
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: 18px;
`;

const AttentionBox = ({ type = 'info', children, ...props }) => {
  const { Icon } = typeStyles[type];
  return (
    <Box $type={type} {...props}>
      <IconWrapper>
        <Icon />
      </IconWrapper>
      {children}
    </Box>
  );
};

export default AttentionBox;
